module.exports = __webpack_public_path__ + "img/map.9781aff2.png";